const idOf = value => (value && typeof value === 'object' ? (value.uuid || value.id || '') : (value || ''));

/** Customer ids a user row says it belongs to. Empty when the API did not send any. */
export const userCustomerIds = (user = {}) => {
    const ids = [
        user.customer_id,
        user.company_id,
        ...(Array.isArray(user.company_ids) ? user.company_ids : []),
        ...(Array.isArray(user.customers) ? user.customers : []),
        ...(Array.isArray(user.customer_ids) ? user.customer_ids : []),
    ].map(idOf).filter(Boolean);
    return [...new Set(ids)];
};

/**
 * True when the row belongs to the customer, or when the API sent no customer ids
 * (the backend `customer_id` filter is then the only guard).
 */
export const belongsToCustomer = (user, customerId) => {
    if (!customerId) return true;
    const ids = userCustomerIds(user);
    return !ids.length || ids.includes(customerId);
};

export const userCurrentProject = (user = {}, projectNames = {}) => {
    const id = idOf(user.project_id) || idOf(user.project_uuid) || idOf(user.project) || idOf(user.allocated_project);
    const name = user.project_name
        || (user.project && typeof user.project === 'object' ? user.project.project_name || user.project.name : '')
        || projectNames[id]
        || '';
    return { id, name };
};

/** Selected users that would be moved out of another project. */
export const usersMovingProject = (users, targetProjectId, projectNames = {}) => users
    .map(user => ({ user, project: userCurrentProject(user, projectNames) }))
    .filter(({ project }) => project.id && project.id !== targetProjectId);

export const assignFailureMessage = (response) => {
    const message = response?.message || 'Users could not be assigned to this project.';
    const ids = response?.errors?.user_ids || response?.data?.user_ids;
    return Array.isArray(ids) && ids.length
        ? `${message} (${ids.length} ${ids.length === 1 ? 'user' : 'users'} not assigned)`
        : message;
};
